import { infiniteQueryOptions, keepPreviousData } from "@tanstack/react-query";

import { SortingRequestParams } from "../../shared/types/api-types";
import { SORT_DIRECTIONS } from "../../shared/types/sort";

import { getCharges } from "./api";
import {
  CHARGE_LIST_QUERY_KEY,
  CHARGE_LIST_SORT_FIELDS,
  CHARGES_COUNT_PER_PAGE,
  ChargeSortColumn,
} from "./constants";
import { GetChargesFilter } from "./types";

export const DEFAULT_CHARGES_LIST_SORTING: SortingRequestParams<ChargeSortColumn> =
  {
    columnName: CHARGE_LIST_SORT_FIELDS.chargeDate,
    direction: SORT_DIRECTIONS.desc,
  };

interface GetInfiniteChargesQueryOptionsParams {
  filter?: GetChargesFilter;
  sorting?: SortingRequestParams<ChargeSortColumn>;
}

export const getInfiniteChargesQueryOptions = ({
  filter = {},
  sorting = DEFAULT_CHARGES_LIST_SORTING,
}: GetInfiniteChargesQueryOptionsParams = {}) =>
  infiniteQueryOptions({
    queryKey: [CHARGE_LIST_QUERY_KEY, filter, sorting],
    queryFn: ({ pageParam }) =>
      getCharges({
        ...filter,
        sorting,
        pagination: {
          page: pageParam,
          countPerPage: CHARGES_COUNT_PER_PAGE,
        },
      }),
    getNextPageParam: (lastPage) =>
      lastPage.pagination?.hasMore
        ? lastPage.pagination.currentPage + 1
        : undefined,
    initialPageParam: 1,
    placeholderData: keepPreviousData,
  });
